import { H4, H6 } from '@blueprintjs/core';
import { AddLarge, Cloud } from '@carbon/icons-react';
import * as React from 'react';
import { Button } from 'vet-bones/design-system/components';

import { useAppDispatch } from 'src/ui/app/hooks';
import {
  LANDING_PAGE_ADD_CONNECTION,
  LANDING_PAGE_GET_STARTED,
} from 'src/ui/constants/testIds';
import { Welcome } from 'src/ui/containers/landing/Welcome';
import { KitsSection } from 'src/ui/containers/marketplace/KitsSection';
import { DialogType, openedDialog } from 'src/ui/features/ui';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import { useMarketplaceSettingsQuery } from 'src/ui/graph/types';
import {
  Module,
  ModuleFilters,
  marketplaceSettingsToDbOptions,
  useMarketplaceList,
} from 'src/ui/hooks/modules';
import * as copy from 'src/ui/templates/copy';
import { DEMO_MODULE_TYPE } from 'src/ui/templates/modules';

export const NewUserLanding: React.VFC = () => {
  const dispatch = useAppDispatch();

  const { data: marketplaceSettingsData } = useMarketplaceSettingsQuery(
    graphQLClient
  );

  const marketplaceConfig = marketplaceSettingsToDbOptions(
    marketplaceSettingsData?.marketplaceSettings
  );

  const filters: ModuleFilters = {
    type: DEMO_MODULE_TYPE,
  };

  const {
    data: moduleData,
    isLoading: isModuleDataLoading,
  } = useMarketplaceList(marketplaceConfig, '', filters);

  const modules = React.useMemo(() => {
    if (isModuleDataLoading || !moduleData) {
      return [];
    }
    const moduleLookup = new Map(
      moduleData.map((module) => [module.id, module])
    );
    const featuredIds = copy.components.home.newUser.kits.featured;
    const featuredModules = featuredIds
      .map((id) => moduleLookup.get(id))
      .filter((module) => module) as Module[];

    return featuredModules;
  }, [moduleData, isModuleDataLoading]);

  const handleAdd = () =>
    dispatch(openedDialog({ type: DialogType.ADD_ENDPOINT }));

  return (
    <>
      <Welcome
        className="welcome-container-voicebox"
        subText={copy.components.home.newUser.cta}
        titleText={copy.components.home.newUser.title}
      />
      <div className="sd-landing-new-user">
        <H4>{copy.components.home.newUser.intro}</H4>
        <KitsSection
          isVoiceboxLink
          kits={modules}
          nonKits={[copy.components.home.newUser.kits.useOwnData]}
        />
        <div className="sd-landing-new-user-actions">
          <H6>{copy.components.home.newUser.endpoint.title}</H6>
          <div className="new-connection-section">
            <Button
              href="/get-started"
              leftIcon={Cloud}
              size="md"
              testId={LANDING_PAGE_GET_STARTED}
              variant="tertiary-accent"
            >
              {copy.components.home.newUser.endpoint.selectPlan}
            </Button>
            <Button
              leftIcon={AddLarge}
              onClick={handleAdd}
              size="md"
              testId={LANDING_PAGE_ADD_CONNECTION}
              variant="tertiary-accent"
            >
              {copy.components.home.newUser.endpoint.connectExisting}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
